// extracted by mini-css-extract-plugin
module.exports = {"root":"Navbar_root__2mQwb","span":"Navbar_span__X102U","button":"Navbar_button__1qOuN","logo":"Navbar_logo__2HuDV","menu":"Navbar_menu__2CWr2","a":"Navbar_a__2C7cC"};